<template>
  <main class="relative isolate grid min-h-dvh place-items-center overflow-y-auto p-4" data-test="pagina-errore">
    <AppBackground fixed />
    <GlassPanel strong padding="lg" class="flex w-full max-w-lg flex-col items-center gap-5 text-center" role="alert">
      <span class="grid size-14 place-items-center rounded-full bg-error-500/10 text-3xl text-error-500" aria-hidden="true">
        <i class="fal fa-exclamation-circle" />
      </span>
      <div class="flex flex-col gap-1.5">
        <h1 class="font-display text-2xl font-semibold text-text-primary" data-test="errore-titolo">{{ t(chiaveTitolo) }}</h1>
        <p class="text-sm text-text-secondary">{{ t("pagina_errore.descrizione") }}</p>
      </div>
      <img src="/error.webp" alt="" width="320" class="h-auto max-w-full" draggable="false" />
      <UiButton :icon="accessoValido ? 'fal fa-arrow-left' : 'fal fa-right-to-bracket'" :label="accessoValido ? t('pagina_errore.torna_indietro') : t('pagina_errore.vai_al_login')" @click="vai" />
    </GlassPanel>
  </main>
</template>

<script setup lang="ts">
// Pagina di errore dell'app (404, 401, errori generici). Con una sessione valida riporta alla prima voce del menu, altrimenti al
// login. Sta fuori dai layout: porta da sola sfondo e vetro.
import { useI18n } from "vue-i18n";

const props = defineProps<{ error: { statusCode?: number } }>();

const { t } = useI18n();
const config = useRuntimeConfig();
const { authFetch } = useAuthFetch();
const menu = useMenuLookup().getMenu() as Array<{ route?: string }>;
const accessoValido = ref(false);

const chiaveTitolo = computed(() =>
  props.error.statusCode === 404 ? "pagina_errore.titolo_404" : props.error.statusCode === 401 ? "pagina_errore.titolo_401" : "pagina_errore.titolo_generale",
);

// Si fida di una sessione solo se il server conferma il token
onMounted(async () => {
  const token = useCookie(`token${config.public.base_progetto}`).value;
  if (typeof token !== "string" || !token) return;
  try {
    accessoValido.value = !!(await authFetch("/api/general/check_token"));
  } catch {
    accessoValido.value = false;
  }
});

const vai = () => clearError({ redirect: accessoValido.value ? (menu[0]?.route ?? "/login") : "/login" });
</script>
